// extracted by mini-css-extract-plugin
export default {"container":"SeriesSelectDnd_container__X9t2T"};